var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDotsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 6,
    viewBox: "0 0 18 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 3C13.125 4.34619 14.2163 5.4375 15.5625 5.4375C16.9087 5.4375 18 4.34619 18 3C18 1.65381 16.9087 0.5625 15.5625 0.5625C14.2163 0.5625 13.125 1.65381 13.125 3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 3C6.5625 4.34619 7.65381 5.4375 9 5.4375C10.3462 5.4375 11.4375 4.34619 11.4375 3C11.4375 1.65381 10.3462 0.5625 9 0.5625C7.65381 0.5625 6.5625 1.65381 6.5625 3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.06547e-07 3C-1.65391e-07 4.34619 1.09131 5.4375 2.4375 5.4375C3.78369 5.4375 4.875 4.34619 4.875 3C4.875 1.65381 3.78369 0.5625 2.4375 0.5625C1.09131 0.5625 -4.77025e-08 1.65381 -1.06547e-07 3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotsIcon);
export default __webpack_public_path__ + "static/media/three-dots-icon.ab728646f2b067b476987b6ef3781934.svg";
export { ForwardRef as ReactComponent };